
/**
 * 시간 관련 정보
 */
export type MessagingGetChatRooms200PageAllOfThreeContentItemTimeInfo = {
  /** 생성 시간 */
  createdAt?: string;
  /** 마지막 수정 시간 */
  updatedAt?: string;
};
